
<div class="bmc-user-group-properties">
  <div class="bmc-user-group-properties__header">
    <h5 class="bz-font-weight--semibold">{{"USER_GROUPS.PROPERTY_LIST" | translate}}</h5>
    <bzg-button-icon class="bmc-user-group-properties__header__icon bz-font-weight--semibold" icon="icon-close-strong" size="s" (click)="close()"></bzg-button-icon>
  </div>
  <ul class="bmc-user-group-properties__body">
    <li class="bmc-user-group-properties__property" *ngFor="let property of properties | keyvalue">
      <div (click)="isExpanded = isExpanded === property.key ? '': property.key" class="bmc-user-group-properties__property__section">
        <span [ngClass]="{'bz-color--theme-600': currentCondition[property.key]}">{{("USER_GROUPS.PROPERTY_" + (property.key | uppercase)) | translate}}<span *ngIf="currentCondition[property.key]">: {{currentCondition[property.key].displayName}} </span></span>
        <bzg-icon *ngIf="property.value.length > 0" [@bzgHorizontalFlip]="isExpanded != property.key" nameIcon="arrow-up-special"></bzg-icon>
      </div>
      <div  class="bmc-user-group-properties__list-container" [@bzgSlideDown] *ngIf="isExpanded === property.key">
    <input class="bmc-user-group-properties__property__filter  bz-space--inset-squish-s" type="text" placeholder="Select a value" [(ngModel)]="searchPropertyValue">
        <ul class="bmc-user-group-properties__list">
          <li *ngFor="let item of property.value | searchBy : searchPropertyValue : ['displayName']" (click)="setProperty(property.key, item); isExpanded = ''" class="bmc-user-group-properties__list__item  bz-space--inset-squish-s">
            {{item.displayName}}
          </li>
        </ul>
      </div>
    </li>
  </ul>
 <div class="bmc-user-group-properties__footer bz-space--inset-m bz-color-border--neutral-200">
    <a class="bz-font-weight--semibold bz-font-size--body-small bz-color--theme-400 bz-space--inline-m" (click)="clearAll()">
      {{'GLOBAL.CLEAR_ALL' | translate}}
    </a>
    <bzg-button-secondary [size]="'s'" (click)="apply()">
      {{'GLOBAL.APPLY' | translate}}
    </bzg-button-secondary>

  </div>
</div>
